import '@/App.scss';

import HomeConfiguration from './routes/Home/HomeConfiguration';
import { useInitLogging } from './utilities/logger/datadog/initialise';
import { useAmplitudeIdentitySync } from './utilities/logger/amplitude/amplitudeIdentity';
import { useInitAmpli } from './utilities/logger/amplitude/initialise';
import { useStore } from '@/store/useStore';
import { getCameraSide } from '@/store/slices/deviceSafeZone/deviceSafeZone';
import { useNativeSafeZonePadding } from '@/logic/use-native-safe-zone-padding';
import '@/utilities/translation/i18nInit';

function App() {
  useInitLogging();
  useInitAmpli();
  useAmplitudeIdentitySync();
  useNativeSafeZonePadding();
  // Android reports the camera side in landscape; the SWJ toggle slot moves to the
  // opposite column (see DefaultControlsOverlay styles) so it clears the cutout.
  const cameraSide = getCameraSide(useStore((s) => s.deviceSafeZone.direction));
  const platform = useStore((s) => s.runtime.platform);

  return (
    <div
      className="corner-layout"
      data-camera-side={cameraSide ?? undefined}
      data-platform={platform}
    >
      <HomeConfiguration />
    </div>
  );
}

export default App;
